export default __webpack_public_path__ + "static/media/camera.4fef4ad6.svg";